// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Keep the existing columns and reserve space above the dashboard Tools. */
.scada-home-layout {
  min-width: 0;
  padding-bottom: 8px;
}

.scada-home-row,
.scada-home-main,
.scada-home-main > div,
.scada-home-map-and-table {
  height: 100%;
  min-height: 0;
  min-width: 0;
}

.scada-home-row > div {
  min-width: 0;
  min-height: 0;
}

.scada-home-map-and-table {
  display: flex;
  flex-direction: column;
}

.scada-home-map {
  flex: 1 1;
  height: auto !important;
  min-height: 0;
}

.scada-home-table {
  flex: 0 1 auto;
  max-height: 45%;
  min-height: 0;
  min-width: 0;
  overflow: auto;
}

.scada-home-table > div {
  flex: 1 1;
  min-width: 0;
}

.scada-home-panel {
  min-height: 0;
}

.scada-home-panel > .tooltitlediv {
  flex-shrink: 0;
}

.scada-home-panel > .scroll-layerdiv,
.scada-home-panel > .scroll-layerdivheight {
  flex: 1 1;
  height: auto;
  min-height: 0;
}

@media (max-width: 767px) {
  .scada-home-layout {
    height: auto !important;
  }

  .scada-home-main {
    height: 65vh;
    min-height: 360px;
  }

  .scada-home-row > div:last-child:not(:first-child) {
    height: 420px !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/GisTools/SCADAHomeLayout.css"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;;EAIE,YAAY;EACZ,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAW;EACX,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,SAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,wBAAwB;EAC1B;AACF","sourcesContent":["/* Keep the existing columns and reserve space above the dashboard Tools. */\n.scada-home-layout {\n  min-width: 0;\n  padding-bottom: 8px;\n}\n\n.scada-home-row,\n.scada-home-main,\n.scada-home-main > div,\n.scada-home-map-and-table {\n  height: 100%;\n  min-height: 0;\n  min-width: 0;\n}\n\n.scada-home-row > div {\n  min-width: 0;\n  min-height: 0;\n}\n\n.scada-home-map-and-table {\n  display: flex;\n  flex-direction: column;\n}\n\n.scada-home-map {\n  flex: 1 1 0;\n  height: auto !important;\n  min-height: 0;\n}\n\n.scada-home-table {\n  flex: 0 1 auto;\n  max-height: 45%;\n  min-height: 0;\n  min-width: 0;\n  overflow: auto;\n}\n\n.scada-home-table > div {\n  flex: 1;\n  min-width: 0;\n}\n\n.scada-home-panel {\n  min-height: 0;\n}\n\n.scada-home-panel > .tooltitlediv {\n  flex-shrink: 0;\n}\n\n.scada-home-panel > .scroll-layerdiv,\n.scada-home-panel > .scroll-layerdivheight {\n  flex: 1 1 0;\n  height: auto;\n  min-height: 0;\n}\n\n@media (max-width: 767px) {\n  .scada-home-layout {\n    height: auto !important;\n  }\n\n  .scada-home-main {\n    height: 65vh;\n    min-height: 360px;\n  }\n\n  .scada-home-row > div:last-child:not(:first-child) {\n    height: 420px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
